const SEARCH = '/search'
const CONTENT = `${SEARCH}/content`
const PEOPLE = `${SEARCH}/people`
const PERSON = `/persons/search`
const USERS = `/user/search`
const GRID_CONTENT = `/contents/search`

export { SEARCH, CONTENT, PEOPLE, PERSON, GRID_CONTENT, USERS }
